import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { SvgIcon } from 'src/components/common/SvgIcon';
import { setBodyOverflow } from 'src/helpers/utils';
import { RootState } from 'src/types/store-types';
import './styles.scss';

const MiniGame: FC = () => {
  const { user } = useSelector((state: RootState) => state.user);
  const [iframeSrc, setIframeSrc] = useState<string>('');
  const { wheelUrl } = useSelector((state: RootState) => state.integrations);
  const { continuePlayGame } = useSelector((state: RootState) => state.app);
  const { game } = useSelector((state: RootState) => state.games);

  useEffect(() => {
    window.__gdlib?.registerCallBack('openMiniGame', () => {
      if (user && wheelUrl) {
        setIframeSrc(wheelUrl);
        setBodyOverflow('unset');
      }
    });

    return () => {
      window.__gdlib?.unRegisterCallBack('openMiniGame');
    };
  }, [wheelUrl, user]);

  const handleClose = (): void => {
    if (continuePlayGame && game) {
      setBodyOverflow('unset');
    } else {
      window.__gdlib?.callRegisteredCB('closeGameBoxGlobalWidget');
      setBodyOverflow('set');
    }
    setIframeSrc('');
  };

  return iframeSrc ? (
    <>
      <SvgIcon src="/images/icons/svg/close.svg" onClick={handleClose} className="close-game" />
      <iframe src={iframeSrc} frameBorder={0} title="Mini game" className="mini-game-frame" />
    </>
  ) : (
    <></>
  );
};

export default MiniGame;
